import { render } from "./OperationalUnitsSettings.vue?vue&type=template&id=0b8c5ac8&scoped=true"
import script from "./OperationalUnitsSettings.vue?vue&type=script&lang=js"
export * from "./OperationalUnitsSettings.vue?vue&type=script&lang=js"

import "./OperationalUnitsSettings.vue?vue&type=style&index=0&id=0b8c5ac8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8c5ac8"]])

export default __exports__